import { buildResult, pass, fail, skip } from "../buildResult";
import { defineTest } from "../defineTest";

export default defineTest("clinical_note_present", "Clinical note exists", ({ patient }) => {
  if (!patient?.patient_id) return skip("No patient record");
  const note = patient.note?.trim();
  if (!note) {
    return fail("Note field is empty");
  }
  if (note.length < 100) {
    return buildResult({
      warnings: [`Note is very short (${note.length} characters)`],
      successes: ["Note field is populated"],
    });
  }
  return pass(`Note present (${note.length} characters)`);
});
